export const validateEsTax = (dni: string, controlLetters: string): boolean => {
  const dniNumber = dni.slice(0, -1).replace(/[^\d]/g, '');
  const letterIndex = +dniNumber % 23;
  const letter = dni.slice(-1).toUpperCase();
  return controlLetters.charAt(letterIndex) === letter;
};
